import React, { Component } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  Empty,
  Tabs,
  Divider,
  Space,
  Tooltip,
  Col,
  Row,
  Pagination,
  Alert,
} from "antd";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import LabATM from "../../components/LabATM";

// import './MediaTrashPage.css'
import "antd/dist/antd.css";
import StyledDropzone from "../../components/StyledDropzone";
import MediaListElement from "../../components/MediaListElement";
import MediaPreviewPopup from "../../components/popups/MediaPreviewPopup";
import { connect } from "react-redux";
import {
  requestFilesServerPost,
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
  updateGlobalSearch,
} from "../../actions";
import path from "path";
import DataHelper from "../../helpers/DataHelper";
import Data from "../../data/data";
import CreateURLMediaView from "../../components/views/CreateURLMediaView";
import PopupManager from "../../managers/PopupManager";
import PermissionManager from "../../managers/PermissionManager";
import FileConversionTasksView from "../../components/views/FileConversionTasksView";
import { TbTrash } from "react-icons/tb";
import MediaLists from "../../components/views/MediaLists";
import { Trash2, AlertTriangle } from "lucide-react";
import { getMediaTypeIcon } from "../../helpers/mediaTypeIcons";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Search } = Input;
const { confirm, info } = Modal;
const { TabPane } = Tabs;

class MediaTrashPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: [],
      currentSelections: [],
      uploadPageVisible: false,
      mediaDatas: [],
      uploadProgress: 0,
      currentPage: 1,
      pageSize: 20,
      currentMediaSize: 1,
      conversionTasks: [],
    };
    const { onToggleSideMenu } = props;

    this.clearFiles = () => {};
    this.uploadProgressUpdate = () => {};
    this.toggle = onToggleSideMenu;
    this.isSettingMediaSize = false;
    this.mediaPreviewPopupRef = React.createRef();
  }

  state = {
    collapsed: false,
    mediaDatas: [],
  };

  updateSelections = (newSelections, callback = () => {}) => {
    console.log("updateSelections " + newSelections);
    if (!newSelections) return;

    this.setState(
      (prevState) => ({
        currentSelections: newSelections,
      }),
      callback,
    );
  };

  updateSelection = (id, value, callback = () => {}) => {
    console.log("updateSelection " + id + " " + value);
    this.setState(
      (prevState) => ({
        currentSelections: value
          ? [...new Set([...prevState.currentSelections, id])] // Ensure uniqueness
          : prevState.currentSelections.filter((d) => d !== id),
      }),
      callback,
    );
  };

  componentDidMount() {
    if (this.props.selectedBrandData) this.updateMediaListData();
  }

  componentDidUpdate = (newProps) => {
    if (
      "selectedBrandData" in newProps &&
      this.props.selectedBrandData !== newProps.selectedBrandData
    ) {
      this.updateMediaListData();
    }
  };

  updateMediaListData = () => {
    const {
      requestServerGet,
      usertoken,
      data = null,
      selectedBrandData,
      globalSearch,
    } = this.props;

    console.log("updateMediaListData");

    if (!selectedBrandData) {
      console.log("no brand data");
      this.setState({ mediaDatas: [] });
      return;
    }

    var params = { brandid: selectedBrandData.BrandID };

    console.log("getting trash files " + params.brandid);
    DataHelper.getTrashFiles(params, this.props).then((data) => {
      console.log("getTrashFiles " + JSON.stringify(data));
      this.setState({ mediaDatas: data });
    });

    // this.updateConversionTasks();
  };
  // updateConversionTasks = () => {

  //     const { requestServerGet, usertoken, data = null, selectedBrandData, globalSearch } = this.props;

  //     console.log("updateConversionTasks")

  //     if (!selectedBrandData) {
  //         console.log("no brand data")
  //         this.setState({ conversionTasks: [] })
  //         return
  //     }

  //     var params = { brandid: selectedBrandData.BrandID };

  //     console.log("getting file conversion tasks " + params.brandid)
  //     DataHelper.getFileConversionTasks(params, this.props).then(data => {
  //         this.setState({ conversionTasks: data })

  //         console.log("updateConversionTasks " + JSON.stringify(data))
  //     })
  // }

  onProgress = (percentCompleted) => {
    this.setState({ uploadProgress: percentCompleted });
  };
  handleFilesUpload = (files) => {
    DataHelper.handleFilesUpload(
      files,
      this.props,
      this.uploadProgressUpdate,
      this.onProgress,
      this.state.uploadProgress,
    ).then(() => {
      this.updateMediaListData();
    });
  };

  onDrop = (files) => {
    this.setState({ images: files });
  };

  mapClearFileFunction = (func) => {
    this.clearFiles = func;
  };

  mapUploadProgressUpdate = (func) => {
    this.uploadProgressUpdate = func;
  };

  showUploadPage = (doShow = true) => {
    if (doShow) {
      this.clearFiles();
    }

    this.setState({ uploadPageVisible: doShow });
  };

  deleteMedia = (data, callback = () => {}) => {
    const { usertoken, requestServerPost, lang } = this.props;
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaTrash;
    const params = { fileids: `${data.FileID}` };

    confirm({
      title: t.deleteConfirm,
      icon: <ExclamationCircleOutlined />,
      centered: true,
      onOk() {
        requestServerPost(
          "delete_trashs",
          params,
          {},
          (response) => {
            console.log("delete complete");
            callback();
          },
          usertoken,
        );
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  restoreMedia = (data, callback = () => {}) => {
    const { usertoken, requestServerPost, lang } = this.props;
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaTrash;
    const params = { fileids: `${data.FileID}` };

    console.log("restore media " + JSON.stringify(data));
    confirm({
      title: t.restoreConfirm,
      icon: <ExclamationCircleOutlined />,
      centered: true,
      onOk() {
        requestServerPost(
          "restore_trashs",
          params,
          {},
          (response) => {
            console.log("restore complete");
            callback();
          },
          usertoken,
        );
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  previewMedia = (data) => {
    console.log("previewMedia " + JSON.stringify(data));
    if (data && this.mediaPreviewPopupRef.current) {
      this.mediaPreviewPopupRef.current.previewMedia(data);
    }
  };

  editMedia = (data) => {
    if (data) {
      const type = data.FileType?.toLocaleLowerCase();
      switch (type) {
        case "directoryurl":
        case "web":
          PopupManager.launchEditWebFilePopup(data, this.updateMediaListData);
        case "videourl":
          PopupManager.launchEditWebFilePopup(data, this.updateMediaListData);
          break;
        case "streamingurl":
          PopupManager.launchEditStreamingURLFilePopup(
            data,
            this.updateMediaListData,
          );
          break;
      }
    }
  };

  deleteCurrentSelections = (callback = () => {}) => {
    const { usertoken, requestServerPost, lang } = this.props;
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaTrash;
    const { currentSelections = [] } = this.state;

    const params = { fileids: currentSelections.join(",") };

    const self = this;
    confirm({
      title: t.deleteSelectedConfirm(currentSelections.length),
      icon: <ExclamationCircleOutlined />,
      centered: true,
      onOk() {
        requestServerPost(
          "delete_trashs",
          params,
          {},
          (response) => {
            console.log("delete complete");
            self.updateSelections([]);
            callback();
          },
          usertoken,
        );
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  emptyTrash = () => {
    const { usertoken, requestServerPost, lang } = this.props;
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaTrash;

    // this.state.mediaDatas
    const allTrashFileIDs = this.state.mediaDatas.map((d) => d.FileID);
    const trashFilesString = allTrashFileIDs.join(",");

    const params = { fileids: trashFilesString };

    const self = this;

    if (allTrashFileIDs.length == 0) {
      info({
        title: t.alreadyEmpty,
        icon: <ExclamationCircleOutlined />,
        centered: true,
      });
    } else {
      confirm({
        title: t.emptyConfirm,
        icon: <ExclamationCircleOutlined />,
        centered: true,
        onOk() {
          requestServerPost(
            "delete_trashs",
            params,
            {},
            (response) => {
              console.log("delete complete");
              self.updateMediaListData();
            },
            usertoken,
          );
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    }
  };

  render = () => {
    const {
      isSideMenuCollapsed = false,
      globalSearch,
      updateGlobalSearch,
      selectedBranchData,
      selectedBrandData,
      lang,
    } = this.props;
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).mediaTrash;

    const isBrandLevel = !selectedBranchData && selectedBrandData;

    const createPermission = PermissionManager.checkPermission(
      isBrandLevel
        ? PermissionManager.PERMISSION_KEY_BRAND_MEDIA_TRASH
        : PermissionManager.PERMISSION_KEY_MEDIA_TRASH,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const editPermission = PermissionManager.checkPermission(
      isBrandLevel
        ? PermissionManager.PERMISSION_KEY_BRAND_MEDIA_TRASH
        : PermissionManager.PERMISSION_KEY_MEDIA_TRASH,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const deletePermission = PermissionManager.checkPermission(
      isBrandLevel
        ? PermissionManager.PERMISSION_KEY_BRAND_MEDIA_TRASH
        : PermissionManager.PERMISSION_KEY_MEDIA_TRASH,
      PermissionManager.PERMISSION_TYPE_DELETE,
    );

    const { currentSelections = [], mediaDatas = [] } = this.state;
    const pageId = isBrandLevel
      ? Constants.BRAND_MEDIA_TRASH_PAGE
      : Constants.MEDIA_TRASH_PAGE;

    const resetAllRefs = () => {
      this.setState({ currentPage: 1 });
      [
        "allRef",
        "imgRef",
        "vidRef",
        "webRef",
        "streamRef",
        "videourlRef",
      ].forEach((r) => {
        if (this[r]) this[r].resetPage();
      });
      updateGlobalSearch("");
    };

    const tabItems = [
      {
        key: "1",
        label: t.tabAll,
        ref: (n) => {
          this.allRef = n;
        },
        type: "",
        icon: getMediaTypeIcon("all", 13),
      },
      {
        key: "2",
        label: t.tabImage,
        ref: (n) => {
          this.imgRef = n;
        },
        type: "image",
        icon: getMediaTypeIcon("image", 13),
      },
      {
        key: "3",
        label: t.tabVideo,
        ref: (n) => {
          this.vidRef = n;
        },
        type: "video",
        icon: getMediaTypeIcon("video", 13),
      },
      {
        key: "4",
        label: t.tabWebsite,
        ref: (n) => {
          this.webRef = n;
        },
        type: "web",
        icon: getMediaTypeIcon("web", 13),
      },
      {
        key: "6",
        label: t.tabStreaming,
        ref: (n) => {
          this.streamRef = n;
        },
        type: "streamingurl",
        icon: getMediaTypeIcon("streamingurl", 13),
      },
      {
        key: "7",
        label: t.tabVideoUrl,
        ref: (n) => {
          this.videourlRef = n;
        },
        type: "videourl",
        icon: getMediaTypeIcon("videourl", 13),
      },
    ];

    return (
      <MainLayout id={pageId} quietTitleBar={true} style={{ padding: 20 }}
      renderBreadCrumb={() => [
        <span style={{ fontSize: 14, fontWeight: 500, color: "#94a3b8", padding: "4px 8px", lineHeight: "22px" }}>
          {t.title || "Media Trash"}
        </span>,
      ]}>
        {/* Page header */}
        <div className="cms-page-header">
          <div className="cms-page-header-info">
            <div
              className="cms-page-header-icon"
              style={{ background: "linear-gradient(135deg, #ef4444, #dc2626)" }}
            >
              <Trash2 size={26} color="#fff" />
            </div>
            <div className="cms-page-header-text">
              <h1>{t.pageTitle}</h1>
              <p>{t.subtitle(mediaDatas.length)}</p>
            </div>
          </div>
          <div
            className="cms-page-header-action"
            style={{ display: "flex", alignItems: "center", gap: 10 }}
          >
            {deletePermission && currentSelections.length > 0 && (
              <button
                onClick={() =>
                  this.deleteCurrentSelections(this.updateMediaListData)
                }
                style={{
                  flex: 1,
                  height: 38,
                  padding: "0 16px",
                  borderRadius: 8,
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  color: "#dc2626",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                }}
              >
                <Trash2 size={14} />{" "}
                {t.deleteSelected(currentSelections.length)}
              </button>
            )}
            {deletePermission && (
              <button
                onClick={() => this.emptyTrash()}
                style={{
                  flex: 1,
                  height: 38,
                  padding: "0 16px",
                  borderRadius: 8,
                  background: "linear-gradient(135deg, #ef4444, #dc2626)",
                  color: "#fff",
                  border: "none",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                }}
              >
                <Trash2 size={14} color="#fff" /> {t.emptyTrash}
              </button>
            )}
          </div>
        </div>

        {/* 30-day warning banner */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            background: "#fffbeb",
            border: "1px solid #fcd34d",
            borderRadius: 12,
            padding: "11px 18px",
            marginBottom: 16,
            color: "#92400e",
          }}
        >
          <AlertTriangle size={15} color="#d97706" style={{ flexShrink: 0 }} />
          <span style={{ fontSize: 13 }}>
            {t.warningText} <strong>{t.warningBold}</strong>
            {t.warningEnd}
          </span>
        </div>

        {/* Tabs + media list */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            border: "1px solid #f1f5f9",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          <Tabs
            defaultActiveKey="1"
            onChange={resetAllRefs}
            style={{ width: "100%" }}
            tabBarStyle={{
              padding: "0 20px",
              marginBottom: 0,
              borderBottom: "1px solid #f1f5f9",
            }}
          >
            {tabItems.map((tab) => (
              <TabPane
                key={tab.key}
                tab={
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      fontSize: 13,
                      fontWeight: 500,
                    }}
                  >
                    {tab.icon}
                    {tab.label}
                  </span>
                }
              >
                <div style={{ padding: "16px 20px" }}>
                  <MediaLists
                    mode="trash"
                    ref={tab.ref}
                    updateSelections={this.updateSelections}
                    updateSelection={this.updateSelection}
                    currentSelections={currentSelections}
                    onPreview={this.previewMedia}
                    onEdit={this.editMedia}
                    onRestore={(data, cb = () => {}) => {
                      this.restoreMedia(data, () => {
                        cb();
                        this.updateMediaListData();
                      });
                    }}
                    onDelete={(data, cb = () => {}) => {
                      this.deleteMedia(data, () => {
                        cb();
                        this.updateMediaListData();
                      });
                    }}
                    mediaDatas={mediaDatas}
                    type={tab.type}
                    searchWord={globalSearch}
                    allowEdit={false}
                    allowDelete={deletePermission}
                  />
                </div>
              </TabPane>
            ))}
          </Tabs>
        </div>

        <MediaPreviewPopup ref={this.mediaPreviewPopupRef} />
      </MainLayout>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedMediaTrashPage = connect(mapStateToProps, {
  updateGlobalSearch,
  requestFilesServerPost,
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(MediaTrashPage);

const MediaTrashPageWithLang = (props) => {
  const { lang } = useProLanguage();
  return <ConnectedMediaTrashPage {...props} lang={lang} />;
};

export default MediaTrashPageWithLang;
